import { organizationManagementStrings } from 'constants/strings'
import { EOrganizationPlan } from 'types/enum'

const SELECT_CLASS =
  'w-full rounded-xl border border-border/80 bg-white px-3 py-2 text-sm text-ink outline-none ring-0 focus:border-ink/30 disabled:opacity-60'

const PLAN_OPTIONS: EOrganizationPlan[] = [
  EOrganizationPlan.LIGHT,
  EOrganizationPlan.BASIC,
  EOrganizationPlan.INTERNAL,
]

type OrganizationPlanFieldProps = {
  label: string
  value: EOrganizationPlan
  onChange: (plan: EOrganizationPlan) => void
  disabled?: boolean
}

export function OrganizationPlanField({
  label,
  value,
  onChange,
  disabled,
}: OrganizationPlanFieldProps) {
  const planLabels = organizationManagementStrings.planLabels

  return (
    <label className="grid gap-2 text-xs font-semibold text-ink">
      {label}
      <select
        name="plan"
        className={SELECT_CLASS}
        disabled={disabled}
        value={value}
        onChange={(event) =>
          onChange(event.target.value as EOrganizationPlan)
        }
      >
        {PLAN_OPTIONS.map((plan) => (
          <option key={plan} value={plan}>
            {planLabels[plan]}
          </option>
        ))}
      </select>
    </label>
  )
}
